import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Jul 18 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { FamilyConverter, jsonConversions, FamilyCreatedDTOConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import { ProductLayer } from '../../transportLayers/product/ProductLayer';
import { CRUTransportLayer } from '../CRUTransportLayer';
import logger from '../../logger';
export var FamilyLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(FamilyLayer, _CRUTransportLayer);

  function FamilyLayer() {
    _classCallCheck(this, FamilyLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(FamilyLayer).call(this, CONSTANTS.API.ENDPOINTS.FAMILIES));
  }

  _createClass(FamilyLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
    /**
     * Finds all Familys in specific category
     * @param categoryId id of requested category
     */

  }, {
    key: "findInCategory",
    value: function findInCategory(categoryId) {
      var _this = this;

      var findInCategoryPromise = api(CONSTANTS.API.ENDPOINTS.FAMILIES_IN_CATEGORY(categoryId)).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
      return findInCategoryPromise;
    }
  }, {
    key: "unassignProducts",
    value: function unassignProducts(productIds) {
      var productLayer = new ProductLayer();
      var unassignProductsPromise = api(CONSTANTS.API.ENDPOINTS.FAMILY_UNASSIGN_PRODUCTS).post({
        productIds: productIds
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(productLayer.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
      return unassignProductsPromise;
    }
  }, {
    key: "setBindings",
    value: function setBindings(updates) {
      var _this2 = this;

      var setBindingsPromise = api(CONSTANTS.API.ENDPOINTS.FAMILY_UPDATE_BINDINGS).post({
        updates: updates
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this2.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
      return setBindingsPromise;
    }
  }, {
    key: "updateTier",
    value: function updateTier(updates) {
      var _this3 = this;

      var updateTierPromise = api(CONSTANTS.API.ENDPOINTS.FAMILY_UPDATE_TIER).post({
        updates: updates
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this3.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
      return updateTierPromise;
    }
  }, {
    key: "updateName",
    value: function updateName(updates) {
      var _this4 = this;

      var updateNamePromise = api(CONSTANTS.API.ENDPOINTS.FAMILY_UPDATE_NAME).post({
        updates: updates
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this4.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
      return updateNamePromise;
    }
  }, {
    key: "createWithAffected",
    value: function createWithAffected(family) {
      var _this5 = this;

      var document = this.getConverter().toDocument(family, jsonConversions);
      var createWithAffectedPromise = api(CONSTANTS.API.ENDPOINTS.FAMILY_CREATE_WITH_AFFECTED) // FIXME: JGr change convertor behavior
      .post(family.numericId ? Object.assign(Object.assign({}, document), {
        numericId: family.numericId
      }) : document, {
        responseType: 'json'
      }) // .post(document, {responseType: 'json'})
      .then(function (response) {
        return _this5.familyCreatedDTOConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return createWithAffectedPromise;
    }
  }]);

  return FamilyLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", FamilyConverter)], FamilyLayer.prototype, "converter", void 0);

__decorate([Inject, __metadata("design:type", FamilyCreatedDTOConverter)], FamilyLayer.prototype, "familyCreatedDTOConverter", void 0);